import { Address } from "viem";

export const specialRouters = [
  "0x12f3E7e3281ebEf98e098F861A6d29920a47142F".toLowerCase(),
  "0xd53A7ba269E7a201177287511483D31cab8436e5".toLowerCase(),
];

export const specialTokens = [
  "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d".toLowerCase(),
  "0x55d398326f99059fF775485246999027B3197955".toLowerCase(),
  "0x2170Ed0880ac9A755fd29B2688956BD959F933F8".toLowerCase(),
  "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c".toLowerCase(),
];

export const processorAddresses: Record<number, Address> = {
  56: "0xE2D8fF2A9b97AeA1De090c423061AC24A23d231D" as Address, // BSC
  8453: "0x6e92F2024bE9288bFD1547e305b08CB35B7D3787" as Address, // Base
  1: "0x254A9736aAC4C83c453c6e2Dc38578ebB4cFab84" as Address, // Ethereum
};

// CHANGE THIS
export const CardProcessor = {
  address: "0xa8049E88Ae64f9894175ef18DE10a647c5AB2FF3",
  abi: [
    {
      inputs: [
        { internalType: "address", name: "_royaltyAddress", type: "address" },
      ],
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "oldOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnerSet",
      type: "event",
    },
    {
      inputs: [],
      name: "addedFee",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "token", type: "address" },
        { internalType: "address", name: "router", type: "address" },
        { internalType: "uint256", name: "minOut", type: "uint256" },
        { internalType: "address", name: "to", type: "address" },
      ],
      name: "buyToken",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
      name: "changeOwner",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "getOwner",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "royaltyAddress",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "royaltyAmt",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "_addedFee", type: "uint256" }],
      name: "setAddedFee",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "_royaltyAddress", type: "address" },
      ],
      name: "setRoyaltyAddress",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "_royaltyAmt", type: "uint256" },
      ],
      name: "setRoyaltyAmt",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "_vailSwap", type: "address" }],
      name: "setVailSwap",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "totalFees",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalProcessed",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "vailSwap",
      outputs: [
        { internalType: "contract IVailSwap", name: "", type: "address" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "to", type: "address" }],
      name: "withdrawETH",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "token", type: "address" },
        { internalType: "address", name: "to", type: "address" },
      ],
      name: "withdrawTokens",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
  ] as const,
};

export const advertisementContract = {
  address: "0xE937c35Deb0c67DC953378028d0424c0dd96d77e",
  abi: [
    { inputs: [], stateMutability: "nonpayable", type: "constructor" },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "oldOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnerSet",
      type: "event",
    },
    {
      inputs: [],
      name: "adSlotNonce",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "adSlots",
      outputs: [
        { internalType: "string", name: "chain", type: "string" },
        { internalType: "string", name: "token", type: "string" },
        { internalType: "string", name: "imageURL", type: "string" },
        { internalType: "string", name: "link", type: "string" },
        { internalType: "uint256", name: "duration", type: "uint256" },
        { internalType: "uint256", name: "startTime", type: "uint256" },
        { internalType: "uint256", name: "escrowAmount", type: "uint256" },
        { internalType: "address", name: "initiator", type: "address" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256[]", name: "_adSlotNonces", type: "uint256[]" },
      ],
      name: "approveAds",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256[]", name: "_adSlotIds", type: "uint256[]" },
      ],
      name: "batchGetAdSlotInfo",
      outputs: [
        { internalType: "string[]", name: "chains", type: "string[]" },
        { internalType: "string[]", name: "tokens", type: "string[]" },
        { internalType: "string[]", name: "imageURLs", type: "string[]" },
        { internalType: "string[]", name: "links", type: "string[]" },
        { internalType: "string[][]", name: "socials", type: "string[][]" },
        { internalType: "uint256[]", name: "durations_", type: "uint256[]" },
        { internalType: "uint256[]", name: "startTimes", type: "uint256[]" },
        { internalType: "uint256[]", name: "escrowAmounts", type: "uint256[]" },
        { internalType: "address[]", name: "initiators", type: "address[]" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256[]", name: "_adSlotIds", type: "uint256[]" },
      ],
      name: "batchIsApproved",
      outputs: [{ internalType: "bool[]", name: "", type: "bool[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256[]", name: "_adSlotIds", type: "uint256[]" },
      ],
      name: "batchIsOldApproved",
      outputs: [{ internalType: "bool[]", name: "", type: "bool[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256[]", name: "_adSlotIds", type: "uint256[]" },
      ],
      name: "batchIsOngoing",
      outputs: [{ internalType: "bool[]", name: "", type: "bool[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256[]", name: "_adSlotIds", type: "uint256[]" },
      ],
      name: "batchIsPendingApproval",
      outputs: [{ internalType: "bool[]", name: "", type: "bool[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256[]", name: "_adSlotIds", type: "uint256[]" },
      ],
      name: "batchIsRejected",
      outputs: [{ internalType: "bool[]", name: "", type: "bool[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
      name: "changeOwner",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256[]", name: "adSlotIds", type: "uint256[]" },
      ],
      name: "clearOldAds",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "durationCosts",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "durations",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "_adSlotId", type: "uint256" }],
      name: "endAd",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "_adSlotId", type: "uint256" }],
      name: "getAdSlotInfo",
      outputs: [
        { internalType: "string", name: "chain", type: "string" },
        { internalType: "string", name: "token", type: "string" },
        { internalType: "string", name: "imageURL", type: "string" },
        { internalType: "string", name: "link", type: "string" },
        { internalType: "string[]", name: "socials", type: "string[]" },
        { internalType: "uint256", name: "duration", type: "uint256" },
        { internalType: "uint256", name: "startTime", type: "uint256" },
        { internalType: "uint256", name: "escrowAmount", type: "uint256" },
        { internalType: "address", name: "initiator", type: "address" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256[]", name: "_adSlotIds", type: "uint256[]" },
      ],
      name: "getApprovalStates",
      outputs: [{ internalType: "uint8[]", name: "", type: "uint8[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getApprovedAdSlots",
      outputs: [{ internalType: "uint256[]", name: "", type: "uint256[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getDurationCosts",
      outputs: [{ internalType: "uint256[]", name: "", type: "uint256[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getDurations",
      outputs: [{ internalType: "uint256[]", name: "", type: "uint256[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getNumApprovedAdSlots",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getNumOldApprovedAdSlots",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getNumPendingAdSlots",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getNumRejectedAdSlots",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getOldApprovedAdSlots",
      outputs: [{ internalType: "uint256[]", name: "", type: "uint256[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getOwner",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getPendingAdSlots",
      outputs: [{ internalType: "uint256[]", name: "", type: "uint256[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getRejectedAdSlots",
      outputs: [{ internalType: "uint256[]", name: "", type: "uint256[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "_adSlotId", type: "uint256" }],
      name: "isApproved",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "_adSlotId", type: "uint256" }],
      name: "isOldApproved",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "_adSlotId", type: "uint256" }],
      name: "isOngoing",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "_adSlotId", type: "uint256" }],
      name: "isPendingApproval",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "_adSlotId", type: "uint256" }],
      name: "isRejected",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "startIndex", type: "uint256" },
        { internalType: "uint256", name: "endIndex", type: "uint256" },
      ],
      name: "paginateApproved",
      outputs: [{ internalType: "uint256[]", name: "", type: "uint256[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "startIndex", type: "uint256" },
        { internalType: "uint256", name: "endIndex", type: "uint256" },
      ],
      name: "paginateOldApproved",
      outputs: [{ internalType: "uint256[]", name: "", type: "uint256[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "startIndex", type: "uint256" },
        { internalType: "uint256", name: "endIndex", type: "uint256" },
      ],
      name: "paginatePending",
      outputs: [{ internalType: "uint256[]", name: "", type: "uint256[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "startIndex", type: "uint256" },
        { internalType: "uint256", name: "endIndex", type: "uint256" },
      ],
      name: "paginateRejected",
      outputs: [{ internalType: "uint256[]", name: "", type: "uint256[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "paymentWallet",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "string", name: "_chain", type: "string" },
        { internalType: "string", name: "_token", type: "string" },
        { internalType: "string", name: "_imageURL", type: "string" },
        { internalType: "string", name: "_link", type: "string" },
        { internalType: "string[]", name: "_socials", type: "string[]" },
        { internalType: "uint8", name: "_durationIndex", type: "uint8" },
      ],
      name: "proposeAd",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256[]", name: "_adSlotNonces", type: "uint256[]" },
      ],
      name: "rejectAds",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "rejectionPercentageToOwner",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256[]", name: "_costs", type: "uint256[]" },
      ],
      name: "setDurationCosts",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256[]", name: "_durations", type: "uint256[]" },
      ],
      name: "setDurations",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "_paymentWallet", type: "address" },
      ],
      name: "setPaymentWallet",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "_percentage", type: "uint256" },
      ],
      name: "setRejectionPercentageToOwner",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
  ] as const,
};

export const ProjectDatabase = {
  address: "0x25B80c5c34207852ee99FA46D906fD3D50bC7559",
  abi: [
    { inputs: [], stateMutability: "nonpayable", type: "constructor" },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "oldOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnerSet",
      type: "event",
    },
    {
      inputs: [],
      name: "FEE_DENOM",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "allListedProjects",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
      name: "changeOwner",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "index0", type: "uint256" },
        { internalType: "uint256", name: "index1", type: "uint256" },
      ],
      name: "changeProjectOrder",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "token", type: "address" },
        { internalType: "address", name: "router", type: "address" },
      ],
      name: "deleteRouterPath",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "token", type: "address" },
        { internalType: "address[]", name: "routers", type: "address[]" },
        { internalType: "uint256", name: "buyFee", type: "uint256" },
        { internalType: "uint256", name: "sellFee", type: "uint256" },
        { internalType: "address", name: "feeDestination", type: "address" },
        { internalType: "string", name: "uri", type: "string" },
      ],
      name: "editListedProject",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "getAllListedProjectInfo",
      outputs: [
        { internalType: "address[]", name: "tokens", type: "address[]" },
        { internalType: "string[]", name: "names", type: "string[]" },
        { internalType: "string[]", name: "symbols", type: "string[]" },
        { internalType: "uint8[]", name: "decimals", type: "uint8[]" },
        { internalType: "uint256[]", name: "buyFees", type: "uint256[]" },
        { internalType: "uint256[]", name: "sellFees", type: "uint256[]" },
        { internalType: "string[]", name: "uris", type: "string[]" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getAllListedProjects",
      outputs: [{ internalType: "address[]", name: "", type: "address[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getAllListedProjectsMetadata",
      outputs: [
        { internalType: "address[]", name: "", type: "address[]" },
        { internalType: "string[]", name: "", type: "string[]" },
        { internalType: "string[]", name: "", type: "string[]" },
        { internalType: "uint8[]", name: "", type: "uint8[]" },
        { internalType: "string[]", name: "", type: "string[]" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "token", type: "address" }],
      name: "getAllProjectInfo",
      outputs: [
        { internalType: "address[]", name: "", type: "address[]" },
        { internalType: "uint256", name: "", type: "uint256" },
        { internalType: "uint256", name: "", type: "uint256" },
        { internalType: "address", name: "", type: "address" },
        { internalType: "string", name: "", type: "string" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "token", type: "address" },
        { internalType: "address", name: "router", type: "address" },
      ],
      name: "getBuyPath",
      outputs: [{ internalType: "address[]", name: "", type: "address[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getOwner",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "token", type: "address" }],
      name: "getProjectInfo",
      outputs: [
        { internalType: "address[]", name: "", type: "address[]" },
        { internalType: "uint256", name: "", type: "uint256" },
        { internalType: "uint256", name: "", type: "uint256" },
        { internalType: "address", name: "", type: "address" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "token", type: "address" }],
      name: "getProjectMetadata",
      outputs: [
        { internalType: "string", name: "", type: "string" },
        { internalType: "string", name: "", type: "string" },
        { internalType: "uint8", name: "", type: "uint8" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "token", type: "address" },
        { internalType: "address", name: "router", type: "address" },
      ],
      name: "getSellPath",
      outputs: [{ internalType: "address[]", name: "", type: "address[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "token", type: "address" }],
      name: "isProjectListed",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "token", type: "address" },
        { internalType: "address[]", name: "routers", type: "address[]" },
        { internalType: "uint256", name: "buyFee", type: "uint256" },
        { internalType: "uint256", name: "sellFee", type: "uint256" },
        { internalType: "address", name: "feeDestination", type: "address" },
        { internalType: "string", name: "uri", type: "string" },
      ],
      name: "listProject",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "listedProjects",
      outputs: [
        { internalType: "uint256", name: "buyFee", type: "uint256" },
        { internalType: "uint256", name: "sellFee", type: "uint256" },
        { internalType: "address", name: "feeDestination", type: "address" },
        { internalType: "string", name: "uri", type: "string" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "token", type: "address" }],
      name: "removeProject",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "token", type: "address" },
        { internalType: "address", name: "feeDestination", type: "address" },
      ],
      name: "setProjectFeeDestination",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "token", type: "address" },
        { internalType: "uint256", name: "buyFee", type: "uint256" },
        { internalType: "uint256", name: "sellFee", type: "uint256" },
      ],
      name: "setProjectFees",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "token", type: "address" },
        { internalType: "address[]", name: "routers", type: "address[]" },
      ],
      name: "setProjectRouters",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "token", type: "address" },
        { internalType: "string", name: "uri", type: "string" },
      ],
      name: "setProjectURI",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "token", type: "address" },
        { internalType: "address", name: "router", type: "address" },
        { internalType: "address[]", name: "path", type: "address[]" },
      ],
      name: "setRouterPath",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
  ],
};


export const MultiChainCardProcessor = {
  abi: [
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "user",
          type: "address",
        },
      ],
      name: "CallFailure",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "user",
          type: "address",
        },
      ],
      name: "CallSuccess",
      type: "event",
    },
    {
      inputs: [
        { internalType: "address", name: "target", type: "address" },
        { internalType: "bytes", name: "externalCallData", type: "bytes" },
        { internalType: "address", name: "failsafeUser", type: "address" },
      ],
      name: "execute",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
  ],
  addresses: {
    56: "0x077536d87B1DFde436F0BFFa806C0be5af21E32b",
    8453: "0xE937c35Deb0c67DC953378028d0424c0dd96d77e",
  },
};

export const ReferralManager = {
  address: "0x2da1BD7a160f02C554a5B11e13A538d5Db850e45",
  abi: [
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "oldOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnerSet",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "referrer",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
      ],
      name: "RefTransfer",
      type: "event",
    },
    {
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "allReferrers",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
      name: "changeOwner",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "getAllReferrers",
      outputs: [{ internalType: "address[]", name: "", type: "address[]" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getOwner",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "ref", type: "address" }],
      name: "getReferrerData",
      outputs: [
        { internalType: "uint256", name: "", type: "uint256" },
        { internalType: "string", name: "", type: "string" },
        { internalType: "uint256", name: "", type: "uint256" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "ref", type: "address" }],
      name: "getReferrerInfo",
      outputs: [
        { internalType: "address[]", name: "", type: "address[]" },
        { internalType: "uint256", name: "", type: "uint256" },
        { internalType: "string", name: "", type: "string" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "string", name: "refcode", type: "string" }],
      name: "getReferrerInfoByCode",
      outputs: [
        { internalType: "address[]", name: "", type: "address[]" },
        { internalType: "uint256", name: "", type: "uint256" },
        { internalType: "string", name: "", type: "string" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "string", name: "code", type: "string" },
        { internalType: "address", name: "user", type: "address" },
      ],
      name: "processRef",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [{ internalType: "string", name: "", type: "string" }],
      name: "referralCodeToAddress",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "referrers",
      outputs: [
        { internalType: "uint256", name: "totalEarned", type: "uint256" },
        { internalType: "string", name: "referralCode", type: "string" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "string", name: "referralCode", type: "string" },
      ],
      name: "register",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "vailSwap_", type: "address" }],
      name: "setVailSwap",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "userToReferrer",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "vailSwap",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
  ] as const,
};

export const SwapRouter = {
  address: "0x03E1Ae5170d86323e7f45741A59DEA7e135A480A",
  abi: [
    {
      inputs: [
        {
          internalType: "address",
          name: "_platformFeeRecipient",
          type: "address",
        },
        { internalType: "address", name: "_referralManager", type: "address" },
        { internalType: "address", name: "_projectDatabase", type: "address" },
      ],
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "oldOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnerSet",
      type: "event",
    },
    {
      inputs: [],
      name: "FEE_DENOM",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "string", name: "ref", type: "string" },
        { internalType: "address", name: "token", type: "address" },
        { internalType: "address", name: "router", type: "address" },
        { internalType: "uint256", name: "minOut", type: "uint256" },
        { internalType: "address", name: "to", type: "address" },
      ],
      name: "buyToken",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
      name: "changeOwner",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "router", type: "address" },
        { internalType: "address", name: "tokenA", type: "address" },
        { internalType: "address", name: "tokenB", type: "address" },
      ],
      name: "getLPStats",
      outputs: [
        { internalType: "uint256", name: "", type: "uint256" },
        { internalType: "uint256", name: "", type: "uint256" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "token", type: "address" },
        { internalType: "int256", name: "amountIn", type: "int256" },
      ],
      name: "getOptimalSwapPath",
      outputs: [
        { internalType: "uint256", name: "maxAmount", type: "uint256" },
        { internalType: "address", name: "optimalRouter", type: "address" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getOwner",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "platformFee",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "platformFeeRecipient",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "projectDatabase",
      outputs: [
        {
          internalType: "contract IProjectDatabase",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "token", type: "address" },
        { internalType: "address", name: "router", type: "address" },
        { internalType: "uint256", name: "amountIn", type: "uint256" },
        { internalType: "bool", name: "isBuy", type: "bool" },
      ],
      name: "quoteSwap",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "referralFee",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "referralManager",
      outputs: [
        {
          internalType: "contract IReferralManager",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "string", name: "ref", type: "string" },
        { internalType: "address", name: "token", type: "address" },
        { internalType: "address", name: "router", type: "address" },
        { internalType: "uint256", name: "amount", type: "uint256" },
        { internalType: "uint256", name: "minOut", type: "uint256" },
      ],
      name: "sellToken",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "_fee", type: "uint256" }],
      name: "setPlatformFee",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "_destination", type: "address" },
      ],
      name: "setPlatformFeeRecipient",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "_projectDatabase", type: "address" },
      ],
      name: "setProjectDatabase",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "_fee", type: "uint256" }],
      name: "setReferralFee",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "_referralManager", type: "address" },
      ],
      name: "setReferralManager",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "router", type: "address" },
        { internalType: "bool", name: "isSpecial", type: "bool" },
      ],
      name: "setSpecialRouter",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "specialRouter",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "withdraw",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "_token", type: "address" }],
      name: "withdrawTokens",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    { stateMutability: "payable", type: "receive" },
  ] as const,
};

export const PriceOracle = {
  address: "0x952B02F1973a1157cfE1B43d62aC6E1e921C5D00",
  abi: [
    {
      inputs: [{ internalType: "address", name: "token", type: "address" }],
      name: "LPStatsForToken",
      outputs: [
        { internalType: "uint256", name: "", type: "uint256" },
        { internalType: "uint256", name: "", type: "uint256" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "token", type: "address" }],
      name: "priceOf",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "priceOfBNB",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "token", type: "address" }],
      name: "priceOfToken",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address[]", name: "tokens", type: "address[]" },
      ],
      name: "pricesOf",
      outputs: [{ internalType: "uint256[]", name: "", type: "uint256[]" }],
      stateMutability: "view",
      type: "function",
    },
  ] as const,
};